import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonRow, IonSegment, IonSegmentButton, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { add, arrowBack, remove, trash, folderOpenOutline } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { empresaAlterar, empresaCarregar, removerFinanceiroCategoriaEmpresa, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import "./FinanceiroCategorias.css";

type Props = {
  abrirMenu: boolean;
  projetoid: string;
  empresaid: string;
  configs: Object;
  abrirInserirAgendamento: boolean;
  onDismiss: () => void;
};

const FinanceiroCategorias: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaCategoriaReceita, setListaCategoriaReceita] = useState<any>([]);
  const [listaCategoriaDespesa, setListaCategoriaDespesa] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [tipo, setTipo] = useState<string>("receita");
  const [nome, setNome] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const inputRef = useRef<any>(null);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarConta();
    if (inputRef.current) {
      inputRef.current.setFocus();
    }
  });


  function carregarConta() {

    const consultar = async () => {

      console.log("aasasasasa", loja);
      let id = loja;

      requestService(empresaCarregar.url.replace("{id}", id.replaceAll(/#/g, '%23')).concat("?filtro=", Buffer.from(loja).toString("base64")), {
        method: empresaCarregar.method,
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          console.log(response);
          setListaCategoriaReceita(response.Item.categoriaReceita || []);
          setListaCategoriaDespesa(response.Item.categoriaDespesa || []);
          setShowLoading(false);
        },
        (error: any) => {
          console.log(error);
          setTextToast("Ocorreu um erro ao carregar as informações, tente novamente em instantes.");
          setShowToast(true);
        });

    }

    consultar();
  }


  function deletarCategoria(nome: any, tipo: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delCategoria = async () => {
      const resp = await fetch(removerFinanceiroCategoriaEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: removerFinanceiroCategoriaEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'nome': nome, 'tipo': tipo }),
          credentials: 'include'
        });
      const retorno = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        setTextToast("Não foi possível concluir a operação, tente novamente em instantes.");
        setShowToast(true);
      }
      else {
        console.log("retorno", retorno);
        setTextToast("Categoria removida com sucesso.");
        setShowToast(true);
        carregarConta();
      }


    }

    delCategoria();

  }

  const loadCategoriaReceita = () => {


    if (listaCategoriaReceita == undefined) return;

    if (listaCategoriaReceita.length === 0) {
      return (

        <div className="financeiro-empty"><span className="financeiro-section-icon"><IonIcon icon={folderOpenOutline} aria-hidden="true" /></span><h3>Nenhuma categoria de {tipo} cadastrada</h3><p>Cadastre categorias para organizar seus lançamentos.</p></div>


      );
    }

    return listaCategoriaReceita.map((value: any, index: any) => (
      <IonItem className="financeiro-category-row" lines="full" key={index}>
        <IonIcon icon={add} slot="start" color="success"> </IonIcon>
        <IonLabel>
          {value}
        </IonLabel>
        <IonButton className="financeiro-delete" fill="clear" hidden={acessos?.configuracoes != 'edicao'} slot="end" aria-label={`Excluir categoria ${value}`} onClick={() => { deletarCategoria(value, tipo) }}><IonIcon slot="icon-only" icon={trash} /></IonButton>


      </IonItem>
    ));
  }

  const loadCategoriaDespesa = () => {


    if (listaCategoriaDespesa == undefined) return;

    if (listaCategoriaDespesa.length === 0) {
      return (

        <div className="financeiro-empty"><span className="financeiro-section-icon"><IonIcon icon={folderOpenOutline} aria-hidden="true" /></span><h3>Nenhuma categoria de {tipo} cadastrada</h3><p>Cadastre categorias para organizar seus lançamentos.</p></div>


      );
    }

    return listaCategoriaDespesa.map((value: any, index: any) => (
      <IonItem className="financeiro-category-row" lines="full" key={index}>
        <IonIcon icon={remove} slot="start" color="danger"> </IonIcon>
        <IonLabel>
          {value}
        </IonLabel>
        <IonButton className="financeiro-delete" fill="clear" slot="end" aria-label={`Excluir categoria ${value}`} onClick={() => { deletarCategoria(value, tipo) }}><IonIcon slot="icon-only" icon={trash} /></IonButton>

      </IonItem>
    ));
  }


  const scrollToTop = () => {
    contentRef.current && contentRef.current.scrollToTop();
  };

  async function handleSegmentChange(e: any) {
    setTipo(e.detail.value);
  }


  function cadastrar() {
    const objectRequest = {
      nome: nome
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    requestService(
      empresaAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?financeirocategoria=" + tipo),
      {
        method: empresaAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          carregarConta();
          setShowDetalhes(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Não foi possível concluir a operação, tente novamente em instantes.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Não foi possível concluir a operação, tente novamente em instantes.");
        setShowToast(true);
        setShowLoading(false);
      })
  }

  return (

    <IonPage className="financeiro-page financeiro-categorias-page">
      <IonHeader className="ion-no-border">
        <IonToolbar className="financeiro-toolbar">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Categorias</IonTitle>
        </IonToolbar>


      </IonHeader>

      <IonContent fullscreen={false}>
        {(
          <IonFab className="financeiro-mobile-add" vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao'}>
            <IonFabButton aria-label="Nova categoria" color="tertiary" class="custom-fab-button" onClick={() => {
              setNome("");
              setShowDetalhes(true);
            }} >
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}
<div className="financeiro-container"><div className="financeiro-heading"><div><h1>Categorias financeiras</h1><p>Organize as categorias de receitas e despesas da sua empresa.</p></div><IonButton
                  fill="solid"
                  size="large"
                  className="financeiro-desktop-add" hidden={acessos?.configuracoes != 'edicao'}
                  onClick={() => {
                    setNome("");
                    setShowDetalhes(true);
                  }}>
                  <IonIcon slot="start" icon={add} />
                  Nova categoria
                </IonButton></div><div className="financeiro-category-tabs"><IonSegment value={tipo} onIonChange={(e) => { scrollToTop(); handleSegmentChange(e); }}>
              <IonSegmentButton value="receita" >
                <IonLabel>Receita</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value="despesa" >
                <IonLabel>Despesa</IonLabel>
              </IonSegmentButton>
            </IonSegment></div>


        <section className="financeiro-grid">
          <div className="financeiro-section-heading"><span className="financeiro-section-icon"><IonIcon icon={folderOpenOutline} aria-hidden="true" /></span><div><h2>Categorias de {tipo}</h2><p>{(tipo === 'receita' ? listaCategoriaReceita : listaCategoriaDespesa)?.length || 0} {(tipo === 'receita' ? listaCategoriaReceita : listaCategoriaDespesa)?.length === 1 ? 'categoria cadastrada' : 'categorias cadastradas'}</p></div></div>
          <div className="financeiro-category-columns" aria-hidden="true"><span>Nome da categoria</span><span>Ações</span></div>
        <IonList hidden={tipo == "despesa"}>
          {loadCategoriaReceita()}

        </IonList>
        <IonList hidden={tipo == "receita"}>
          {loadCategoriaDespesa()}
        </IonList>

        </section></div>

        <IonModal onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
          setNome("");
        }}>


          <>
            <IonHeader className="ion-no-border">
              <IonToolbar>
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>Nova categoria - {tipo}</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="financeiro-form-content">
              <IonGrid>
                <IonRow>
                  <IonCol>
                    <IonList>

                      <IonItem lines="none" className="financeiro-category-field">
                        <IonLabel position="stacked">Nome*</IonLabel>
                        <IonInput placeholder="Digite o nome da categoria" value={nome} ref={(ref) => inputRef.current = ref} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
                      </IonItem>
                    </IonList>
                  </IonCol>
                </IonRow>
              </IonGrid>

            </IonContent>
            <IonFooter className="ion-no-border financeiro-form-footer">
              <IonToolbar>
                <IonButton onClick={() => cadastrar()} expand="block" type="submit">Cadastrar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage>
  );


};

export default FinanceiroCategorias;
